import { useAppConstantsContext } from '@/context/AppConstants';
import { Button, Modal, Stack, Text } from '@/theme/index';

interface AdditionalRecordsModalProps {
  recordsFound: string[];
  showModal: boolean;
  handleOnClose: () => void;
}

export const AdditionalRecordsModal = ({
  handleOnClose,
  recordsFound,
  showModal,
}: AdditionalRecordsModalProps) => {
  const {
    images: { imgPremiumData },
  } = useAppConstantsContext();

  const joinWithAnd = (arr: string[]): string => {
    if (arr.length === 1) {
      return arr[0];
    }

    const joined = arr.slice(0, -1).join(', ');
    return `${joined} and ${arr[arr.length - 1]}`;
  };

  const title =
    (recordsFound.length && 'Additional Records Found') ||
    'No Additional Records Found';

  const description =
    recordsFound.length > 0
      ? `New ${joinWithAnd(recordsFound)} found.`
      : 'Try searching again at a later time.';

  return (
    <Modal open={showModal}>
      <Stack
        width={{ xs: 'auto', sm: '396px' }}
        height="197px"
        alignItems="center"
        justifyContent="space-between"
      >
        <img
          src={
            (recordsFound.length && imgPremiumData?.imgCheckIcon) ||
            imgPremiumData?.imgCheckIcon
          }
          alt="Check Icon"
        />
        <Text variant="h3">{title}</Text>
        <Text variant="body1" textAlign="center">
          {description}
        </Text>
        <Button
          variant="text"
          onClick={handleOnClose}
          sx={{
            ml: 'auto',
            textDecoration: 'underline',
            ':hover': { textDecoration: 'underline' },
          }}
        >
          Close
        </Button>
      </Stack>
    </Modal>
  );
};
